export default __webpack_public_path__ + "static/media/ENCTSCard.771900fe.png";